import { Pagination, Select } from 'antd'
import React from 'react'
import { IoCaretDown } from 'react-icons/io5'

const CustomPagination = ({
  isShowPageSize,
  pageSize = 25,
  currentPage = 1,
  totalData = 50,
  optionPageSize = [
    { value: 25, label: '25 items' },
    { value: 50, label: '50 items' },
    { value: 75, label: '75 items' },
    { value: 100, label: '100 items' }
  ],
  onPageSizeChange = () => {},
  onPaginationChange = () => {}
}) => {
  return (
    <div className={`flex flex-col lg:flex-row ${isShowPageSize ? 'lg:justify-between' : 'justify-center'} gap-4 items-center w-full`}>
      {isShowPageSize && (
        <Select
          prefix={<span className="text-secondary">Tampilkan: </span>}
          className="w-full lg:w-[160px] h-10"
          suffixIcon={<IoCaretDown className="fill-primary" />}
          defaultValue={parseInt(pageSize)}
          onChange={onPageSizeChange}
          options={optionPageSize}
        />
      )}
      <Pagination
        total={totalData}
        current={parseInt(currentPage)}
        onChange={onPaginationChange}
        pageSize={parseInt(pageSize)}
        size="default"
        showSizeChanger={false}
      />
    </div>
  )
}

export default CustomPagination
